import { createTheme } from "@mui/material";

const getMuiTheme = () =>
	createTheme({
		components: {
			MUIDataTable: {
				styleOverrides: {
					root: {
						boxShadow: "none",
						borderRadius: 0,
						paddingTop: 20,
						zIndex: 0,
						marginBottom: 80,
						overflow: "hidden",
						position: "relative",
						fontFamily: "Varela Round",
					},
					paper: {
						boxShadow: "none",
					},
				},
			},
			MuiTableCell: {
				styleOverrides: {
					root: {
						fontFamily: "Varela Round",
						fontSize: 16,
					},
				},
			},
			MuiButton: {
				styleOverrides: {
					root: {
						fontFamily: "Varela Round",
						fontSize: 16,
					},
				},
			},

			MUIDataTableSelectCell: {
				styleOverrides: {
					headerCell: {
						fontFamily: "Varela Round",
					},
				},
			},
			MuiTablePagination: {
				styleOverrides: {
					selectLabel: {
						fontFamily: "Varela Round",
					},
					displayedRows: {
						fontFamily: "Varela Round",
					},
				},
			},
			MuiSelect: {
				styleOverrides: {
					select: {
						fontFamily: "Varela Round",
						fontSize: 16,
					},
				},
			},
		},
	});

export default getMuiTheme;
